export default function CollapsePlusIcon({ color = "currentColor" }) {
  return (
    <svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="13" cy="13.0002" r="11.6667" stroke={color} />
      <path d="M13 6V20" stroke={color} strokeLinejoin="round" />
      <path d="M6 13H20" stroke={color} strokeLinejoin="round" />
    </svg>
  );
}
